<template >
  <el-dialog
    :title="'审批流程'"
    :close-on-click-modal="false"
    :visible.sync="visible" style="text-align: left">
    <el-timeline :reverse="true">
      <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :color="activity.color"
              :size="'large'"
              :timestamp="activity.timestamp">
        {{activity.content}}
      </el-timeline-item>
    </el-timeline>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>


  export default {
    data () {
      return {
        visible: false,
        images:[],
        form:{},
        activities:[]
      }
    },
    created () {

    },
    methods: {
      init (id) {
        if(!id) return
        this.activities=[]
        this.form =id
        this.visible = true
        this.$nextTick(() => {
          console.log('aaaaaaaaaa')
            if(this.form.status ==='4') {
             var obj ={};
             obj.timestamp = this.form.sbsj;
             obj.content = this.form.sbrxm + ' 上报问题';
              this.activities.push(obj);
            } else if( this.form.status ==='0') {
              var obj ={};
              obj.timestamp = this.form.sbsj;
              obj.content = this.form.sbrxm + ' 上报问题';
              this.activities.push(obj);
              var obj1={}
              obj1.content = this.form.shrxm+' 审核通过'
              obj1.timestamp = this.form.shsj
              obj1.color='#0bbd87'
              this.activities.push(obj1);
            }else if( this.form.status ==='1') {
              var obj ={};
              obj.timestamp = this.form.sbsj;
              obj.content = this.form.sbrxm + ' 上报问题';
              this.activities.push(obj);
              var obj1={}
              obj1.content = this.form.shrxm+' 审核被拒'
              obj1.timestamp = this.form.shsj
              obj1.color='#e81018'
              this.activities.push(obj1);
            }else if( this.form.status ==='2') {
              var obj ={};
              obj.timestamp = this.form.sbsj;
              obj.content = this.form.sbrxm + ' 上报问题';
              this.activities.push(obj);
              var obj1={}
              obj1.content = this.form.shrxm+' 审核通过'
              obj1.timestamp = this.form.shsj
              obj1.color='#0bbd87'
              this.activities.push(obj1);
              var obj2={}
              obj2.content = this.form.sprxm+' 审批通过'
              obj2.color='#0bbd87'
              obj2.timestamp = this.form.spsj
              this.activities.push(obj2);
            }else if( this.form.status ==='3') {
              var obj ={};
              obj.timestamp = this.form.sbsj;
              obj.content = this.form.sbrxm + ' 上报问题';
              this.activities.push(obj);
              var obj1={}
              obj1.content = this.form.shrxm+' 审核通过'
              obj1.timestamp = this.form.shsj
              obj1.color='#0bbd87'
              this.activities.push(obj1);
              var obj2={}
              obj2.content = this.form.sprxm+' 审批被拒'
              obj2.timestamp = this.form.spsj
              obj2.color='#e81018'
              this.activities.push(obj2);
            }
        })
      },





    }
  }
</script>

<style lang="scss" >
  #left .el-form-item__content{
    text-align: left;
  }
  .menu-list__input,
  .icon-list__input {

    > .el-input__inner {
      cursor: pointer;
    }

  }

  .mod-menu__icon-popover {
    max-width: 350px;
  }

  .mod-menu__icon-list {
    max-height: 380px;
    padding: 0;
    margin: -8px 0 0 -8px;

    > .el-button {
      padding: 8px;
      margin: 8px 0 0 8px;

      > span {
        display: inline-block;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        font-size: 18px;
      }

    }
  }

  .icon-list__tips {
    font-size: 18px;
    text-align: center;
    color: #e6a23c;
    cursor: pointer;
  }
</style>
